import React, { useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import SpeakerNotesTwoToneIcon from "@material-ui/icons/SpeakerNotesTwoTone";
import EmojiPeopleTwoToneIcon from "@material-ui/icons/EmojiPeopleTwoTone";
import ExploreTwoToneIcon from "@material-ui/icons/ExploreTwoTone";

const useStyles = makeStyles((theme) =>
  createStyles({
    topContainer: {
      paddingLeft: 16,
      paddingBottom: 8,
    },
    iconDiv: {
      paddingRight: 8,
    },
    textDiv: {
      paddingTop: 2,
      fontSize: 16,
    },
  })
);

interface MoAboutMenu {
  setOpen: any;
  setExpanded: any;
}

function MoAboutMenu({ setOpen, setExpanded }: MoAboutMenu) {
  const classes = useStyles();

  return (
    <Grid xs={12} item>
      <Grid xs={12} item container className={classes.topContainer}>
        <Grid className={classes.iconDiv}>
          {/* <ArrowForwardIcon style={{}} /> */}
          {/* <FontAwesomeIcon icon={faMap} /> */}
          <EmojiPeopleTwoToneIcon style={{}} />
        </Grid>
        <Grid className={classes.textDiv}>
          <Link
            to={"/about"}
            onClick={() => {
              setOpen(false);
              setExpanded(false);
            }}
          >
            문화재 소개
          </Link>
        </Grid>
      </Grid>
      <Grid xs={12} item container className={classes.topContainer}>
        <Grid className={classes.iconDiv}>
          {/* <ArrowForwardIcon style={{}} /> */}
          {/* <FontAwesomeIcon icon={faMap} /> */}
          <SpeakerNotesTwoToneIcon style={{}} />
        </Grid>
        <Grid className={classes.textDiv}>
          <Link
            to="/notice"
            onClick={() => {
              setOpen(false);
              setExpanded(false);
            }}
          >
            공지 사항
          </Link>
        </Grid>
      </Grid>
      <Grid xs={12} item container className={classes.topContainer}>
        <Grid className={classes.iconDiv}>
          {/* <ArrowForwardIcon style={{}} /> */}
          {/* <FontAwesomeIcon icon={faMap} /> */}
          <ExploreTwoToneIcon style={{}} />
        </Grid>
        <Grid className={classes.textDiv}>
          <Link
            to={"/map"}
            onClick={() => {
              setOpen(false);
              setExpanded(false);
            }}
          >
            찾아 오시는 길
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MoAboutMenu;
